import { useQuery } from '@apollo/client';
import { Trans } from '@lingui/macro';
import React, { FC, useState } from 'react';

import { TLatestRequest } from 'Components/LatestRequests/LatestRequests.helpers';
import { Heading2 } from 'uikit/Heading';

import { LatestRequestsResponse, selectDataSource, selectQuery, trackDetailsClick } from './LatestRequests.helpers';
import './LatestRequests.scss';
import RequestCard from './RequestCard';
import RequestsModal from './RequestModal';

type Props = {
  l2Slug?: string;
  l3Slug?: string;
  citySlug?: string;
};

const LatestRequests: FC<Props> = (props) => {
  const [requestModal, setRequestModal] = useState<TLatestRequest | null>(null);
  const { l2Slug, l3Slug, citySlug } = props;
  const categorySlug = l2Slug || l3Slug;
  const { data } = useQuery<LatestRequestsResponse>(selectQuery(props), {
    variables: {
      slug: l2Slug || l3Slug,
      city: citySlug,
    },
    skip: !categorySlug && !citySlug,
  });

  if (!data) return null;

  const requests = selectDataSource(data);

  if (!requests.length) return null;

  const onDetailsClick = (request: TLatestRequest): void => {
    setRequestModal(request);
    trackDetailsClick(props);
  };

  return (
    <section id="latest-requests" className="latestRequests">
      <div className="container">
        <Heading2 className="latestRequests__title">
          <Trans>Ostatnie zlecenia</Trans>
        </Heading2>
        <div className="latestRequests__wrap">
          {requests.map((item) => (
            <RequestCard key={item.id} {...item} onDetailsClick={onDetailsClick} />
          ))}
        </div>
      </div>
      <RequestsModal handleClose={() => setRequestModal(null)} data={requestModal} />
    </section>
  );
};

export default LatestRequests;
